import 'slick-carousel/slick/slick';
import $ from "jquery";
import { CountUp } from '../components/countUp';
import '../components/waypoints';

class Home {
    constructor() {

        console.log('Home');

        $('.scroll-hash').on('click', function (e) {
            e.preventDefault();
            var hashLink = this.hash;
            window.scroll({
                top: $(hashLink).offset().top,
                behavior: 'smooth'
            });
        });

        $('.slider').slick({
            dots: true,
            infinite: true,
            // autoplay:true,
            // autoplaySpeed:3500,
            // speed: 300,
            rows: 0,
            slidesToShow: 1,
            fade: true,
            prevArrow: $('.buttonsnavsllider .prev'),
            nextArrow: $('.buttonsnavsllider .next'),
        });

        function countStart() {
            const counters = document.querySelectorAll(".js-count-up"),
                options = {
                    useEasing: true,
                    useGrouping: true,
                    separator: ",",
                    decimal: "."
                };

            counters.forEach((item) => {
                const value = item.dataset.value;
                const counter = new CountUp(item, value, options);
                counter.start();
            });
        }

        new Waypoint({
            element: document.querySelector('.numbers-about'),
            handler: function () {
                countStart()
                //this.destroy() //for once
            },
            offset: '50%'
        });

    }
}

export default Home;